import {urlBuilder} from "@torim-app/utils";

const serverHost = `${import.meta.env.VITE_BACKEND_URL}`

export const clientUrlBuilder = (
  queryParams: Record<string, string>,
  path = ''
): string => {
  return urlBuilder(`${serverHost}/client`, queryParams, path);
}
